module.exports = __webpack_public_path__ + "static/media/Hydraulics-Oil-Comparison@3x-100.e5084024.png";